import { Record } from 'immutable';

export const ROLES = {
  accountant: 'accountant',
  user: 'user',
  'confidential-user': 'confidential-user',
  supplier: 'supplier',
};

export function userAdapter({ userId, chatUser, chatToken, userGUID }) {
  const userFactory = new Record({
    userId: null,
    chatUser: null,
    chatToken: null,
    userGUID: null,
  });
  return userFactory({
    userId,
    chatUser,
    chatToken,
    userGUID,
  });
}

export const Apps = {
  AP: 'AP',
  PAY: 'PAY',
  MC: 'MC',
};
